<template>
  <div class="my-layout-box p-receiver-address">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :isSearchShow='isSearchShow'
      :listMap="listMap">
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getAddress } from "~/api/userCenter";

export default {
  name: "receiverAddress",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: false,
      isSearchShow: false,
      listMap: itemsData,
    };
  },
  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      searchData.value = searchData.value;
      const list = await getAddress();
      const data = {
        List: list,
        Total: list.length
      };
     return data
    }
  }
};
</script>

<style lang="less" scope></style>
